webpackJsonp([100268778136406],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Insurance = function Insurance() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Insurance'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I am happy to bill your insurance at no cost. Please remember that you are responsible for the full cost of your visit, whether or not your insurance company pays for the visit.',
	      _react2.default.createElement(
	        'u',
	        null,
	        'Please ensure that your benefits include acupuncture prior to your appointment.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I am a preferred provider with a number of insurance companies, including:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'AccessOne Consumer Health'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Ambetter Coordinated Care'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Aetna WA CAM'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'First Choice Health'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Great-West Healthcare'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Health Allies'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Health Net Life'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Health Net Oregon'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Humana'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Lifewise'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Medical Resource, LLC'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Premera'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'United Healthcare'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you do not see your insurance company listed here, please contact me, as this list is subject to change. I am also able to bill many insurance companies, including BlueCross Blue Shield and Regence, as an out of network provider.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I accept all PIP claims (auto accidents). If you are paying through PIP, please complete this form and bring it with your to your first session.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I also provide super bills for you to submit to your insurance provider for reimbursement upon request.'
	    )
	  );
	};
	
	exports.default = Insurance;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-insurance-js-5c09223d61ca7b3998ea.js